import {HttpRequest,HttpMethod} from "./http";

class POProvider extends HttpRequest {

	// CRUD Product	
	POCreate(params) {
		return this.request(HttpMethod.Post,`/api/v1/wms/po`,params );
	}

	PODuplicate(params) {
		return this.request(HttpMethod.Post,`/api/v1/wms/po/duplicate`,params );
	}

	POList(params) {
		return this.request(HttpMethod.Get,`/api/v1/wms/po`,params );
	}

	PODetail(params) {
		return this.request(HttpMethod.Get,`/api/v1/wms/po/detail`,params );
	}

	POGetFile(params) {
		return this.request(HttpMethod.Get,`/files/${params}`);
	}

	POUpdate(id,params) {
		return this.request(HttpMethod.Put,`/api/v1/wms/po/${id}`,params );
	}

    POApprove(id,params) {
		return this.request(HttpMethod.Put,`/api/v1/wms/po/approve/${id}`,params );
	}

    POCanncel(id,params) {
		return this.request(HttpMethod.Put,`/api/v1/wms/po/cancel/${id}`,params );
	}

    POPartialClose(id,params) {
		return this.request(HttpMethod.Put,`/api/v1/wms/po/close/partial/${id}`,params );
	}

	PODelete(id) {
		return this.request(HttpMethod.Delete,`/api/v1/wms/po/${id}`);
	}


}

export default POProvider